import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { Route, Link, withRouter } from 'react-router-dom'
import MediaQuery from 'react-responsive';
import FM from './FM'
import ZD from './ZD'
import Search from './Search'
import ScrollManager from 'window-scroll-manager'
import { connect } from 'react-redux'
import routes from '~/routes'
import { matchRoutes } from 'react-router-config'

const sm = new ScrollManager();

import {
  setRoute
} from '~/menu/actions'


const ActiveLink = ({ label, to, activeOnlyWhenExact, main }) => (
  <Route path={to} exact={activeOnlyWhenExact} children={({ match }) => (
      <Link className={match && main ? 'active main' : match ? 'active' : main ? 'main' : ''} to={to}>{label}</Link>
  )}/>
)

const Fade = ({ children, ...props }) => (
  <CSSTransition
    {...props}
    timeout={400}
    classNames="bla"
  >
    {children}
  </CSSTransition>
)


class Menu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      smallMenuToggle: false,
      currentComponent: undefined
    }
    this.toggleSmallMenu = this.toggleSmallMenu.bind(this)
    this.windowScroll = this.windowScroll.bind(this)
    this.myRef = React.createRef()
    if (typeof(window) !== "undefined") {
      window.addEventListener('window-scroll', this.windowScroll)
    }
  }

  whichComponent() {
    const { dispatch } = this.props
    const matches = matchRoutes(routes, this.props.location.pathname)

    const matchedRoutes = matches.map((item) => {
      var name
      let dN = item.route.component.displayName
      if (dN) {
        name = dN.replace(/Connect\((\w*)\)/, '$1')
      }
      else {
       name = item.route.component.name
      }
      return { match: item.match, component: name }
    })
    dispatch( setRoute(matchedRoutes))

    if (this.state.currentComponent !== matchedRoutes[0].match.path ){
      this.setState({currentComponent: matchedRoutes[0].match.path})
    }

  }
  componentWillMount() {
    this.whichComponent()
  }
  componentDidUpdate() {
    this.whichComponent()

  }

  windowScroll(event) {
    if (this.state.currentComponent === '/') {
      const node = this.myRef.current
      if (node.offsetHeight <= event.detail.scrollPositionY ) {
        node.className = "small"
      } else {
        node.className = "small"
      }
    }
  }
  toggleSmallMenu(event) {
    //subjects.showMenu.next(!this.state.smallMenuToggle)
    let toggle = !this.state.smallMenuToggle
    let routes = document.getElementsByClassName('routes')[0]
    if(toggle) {
      if(!routes.classList.contains('menu-visible'))
      {
        routes.classList.add('menu-visible')
      }
    }
    else {
      routes.classList.remove('menu-visible')
    }
    this.setState(prevState => ({
      smallMenuToggle: !prevState.smallMenuToggle
    }))
    //console.log(this.state.smallMenuToggle)
  }

  render(){
    let mQVal = (__SERVER__) ? { width: 1200 } : {}

    const menu =
      [
        {
          to: "/about",
          label: "About",
          children: [
            { to: "/faqs", label: "FAQs" },
            { to: "/governance", label: "Governance" },
            { to: "/contacts", label: "Contact"}
          ]
        },
        {
          to: "/participate",
          label: "Participate",
          children: [
            { to: "/training", label: "Training" },
            { to: "/music-submissions", label: "Music Submissions" },
            { to: "/events", label: "Events" },
            { to: "/hot100", label: "HOT 100" },
            { to: "/hot100-archive", label: "HOT 100 Archive" },
          ]
        },
        {
          to: "/support",
          label: "Support",
          children: [
            // { to: "/april-atonement", label: "April Atonement" },
            // { to: "/radiothon", label: "Radiothon" },
            { to: "https://support.4zzz.org.au/merch", label: "Merch", outside: true },
            { to: "/subscribers/discounters", label: "Sub Discounters" },
            { to: "/subscribers/bands", label: "Subscriber Bands" },
            { to: "/accommodation-notices", label: "Accommodation Notices" },
            { to: "/sponsorship", label: "Sponsorship" },
            { to: "/monthly-subscriber-prize-draw", label: "Monthly Sub Prize" },
          ]
        },
        {
          to: "/grid",
          label: "Schedule",
          children: [
            { to: "/programs", label: "Programs"}
          ]
        },
        {
          to: "/reviews",
          label: "Reviews",
          children: [
            { to: "/news", label: "News"},
            { to: "/reviews/albums", label: "New Releases" },
          ]
        }
    ]

    return (
      <nav id="zed-menu" className={this.state.currentComponent === '/' ? 'small' : 'small'} ref={this.myRef}>
        <div className="top-menu">
          <div className="content" >

          <Link to="/" title="4ZZZ" rel="home">
            <img className="logo" src="/assets/4zzz-cutout-white.svg" alt="4ZZZ Logo" />
          </Link>


          <ul id="system-menu">
            <div className="menu-button">
              {/* <input style={{float: 'right'}} checked={this.state.smallMenuToggle} className="tgl tgl-flat" id="cb4" type="checkbox" onChange={this.toggleSmallMenu} />
              <label style={{float: 'right'}} className="tgl-btn" data-tg-off="Nope" data-tg-on="Yeah!" htmlFor="cb4"></label> */}
              <button type="button" className={ this.state.smallMenuToggle ? 'checked test-button fa-solid' : 'test-button fa-solid' } onClick={this.toggleSmallMenu}></button>
              <div className="smallMenu">
                  <div onClick={this.toggleSmallMenu} className="small-menu">
                    <ul>
                      { menu.map((item, index) => (
                       <li key={index}>{item.outside && item.outside ? <a href={item.to} target="_blank">{item.label}</a> : <ActiveLink to={item.to}   label={item.label} main={item.main} />
                        }

                        { item.children &&
                        <ul>
                          {item.children.map((item, index) => (
                          <li key={index}>{item.outside && item.outside ? <a href={item.to} target="_blank">{item.label}</a> :  <ActiveLink to={item.to}   label={item.label} main={item.main} />
                          }</li>
                          ))}
                        </ul> } 
                        </li>


                      ))}
                      <li><FM /></li>
                      <li><ZD /></li>
                    </ul>
                  </div>
              </div>
              <li><FM /></li>
              <li><ZD /></li>
              <Search currentComponent={this.state.currentComponent} />
            </div>
          </ul>
          </div>
        </div>
      </nav>
    )
  }
}

export default withRouter(connect() (Menu))
